

export const ContactPresentation = () => {
  return (
    <div className="contact-presentation">
        <h3>Travel Center Guatemala</h3>
        <h3>+502 5758-6000</h3>
        <h5>travelcenterguatemala@gmail.com</h5>
    </div>
  )
}
